
const digest = 'f9d2d9640bfa81faa20fbbbe53640006483af2de370a717eae404346c2ea317a';
const css = `._textWrapper_x1rng_1 {
	margin-bottom: 0;
}
._searchWrapper_x1rng_4 {
	background-color: #fff;
	border-radius: 15px;
	padding: 20px;
	margin-bottom: 1.5rem;
	._searchInput_x1rng_9 {
		border: 1px solid #c1cbe4 !important;
		min-height: 55px;
		font-size: 14px;
		font-weight: 400;
		border-radius: 15px;
		box-shadow: inset 0 3px 0 0 rgb(198 214 240 / 50%);
		padding: 18px 39px !important;
		color: #000;
		background-color: #dce7fa;
		position: relative;
		background-image: url(/dist/patientV3/icons/search.svg);
		background-repeat: no-repeat;
		background-position: left 15px center;
		display: block;
		width: 100%;

		&:focus {
			box-shadow: 0 0 0 3px rgba(22, 101, 216, 0.15),
				inset 0 4px 0 0 rgba(226, 229, 237, 0.3) !important;
			border-color: #212357 !important;
		}
	}
}
`;

(function() {
  if (typeof document === 'undefined') {
    return;
  }
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"textWrapper":"_textWrapper_x1rng_1","searchWrapper":"_searchWrapper_x1rng_4","searchInput":"_searchInput_x1rng_9"};
export { css, digest };
  